var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00195 0C10.8678 0.000197368 14.002 3.13413 14.002 7C14.0018 10.8657 10.8677 13.9998 7.00195 14C3.13607 14 0.00212993 10.8658 0.00195312 7C0.00195312 3.13401 3.13596 0 7.00195 0ZM10.5283 4.34766C10.272 4.09152 9.85585 4.09144 9.59961 4.34766C9.59342 4.35385 9.58841 4.36128 9.58301 4.36816L6.54395 8.23926L4.71289 6.40723C4.45662 6.15095 4.04046 6.15097 3.78418 6.40723C3.5279 6.66351 3.5279 7.07966 3.78418 7.33594L6.09961 9.65137C6.35589 9.90765 6.77204 9.90765 7.02832 9.65137C7.03402 9.64567 7.03891 9.63911 7.04395 9.63281L10.5371 5.2666C10.784 5.00965 10.7815 4.60079 10.5283 4.34766Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMark);
export default __webpack_public_path__ + "static/media/mark.b21b0d97f8271fd1ab2ec2a08c00a34f.svg";
export { ForwardRef as ReactComponent };